import clx from 'classnames'
import { Tabs } from 'antd'
import styles from './Tabs.css'

const DashboardTabs = ({ children, className, ...restProps }) => {
  return (
    <Tabs
      className={clx(styles.dashboardTabs, className)}
      animated={false}
      size='large'
      tabBarGutter={2}
      {...restProps}
    >
      {children}
    </Tabs>
  )
}

export default DashboardTabs
